export let NotifyType = /*#__PURE__*/function (NotifyType) {
  NotifyType["ORDER"] = "order";
  NotifyType["PROMOTION"] = "promotion";
  NotifyType["NONE"] = "none";
  return NotifyType;
}({});
export let NotifyTemplateType = /*#__PURE__*/function (NotifyTemplateType) {
  NotifyTemplateType["NONE"] = "none";
  NotifyTemplateType["ARTICLE"] = "article";
  NotifyTemplateType["PRODUCT"] = "product";
  NotifyTemplateType["PROMOTION"] = "promotion";
  NotifyTemplateType["OPEN_LINK"] = "open_link";
  NotifyTemplateType["ORDER"] = "order";
  NotifyTemplateType["SELL_ORDER"] = "sell_order";
  return NotifyTemplateType;
}({});
//# sourceMappingURL=notify.enum.js.map